<!--Have ngIf as a work around to resolve flex-direction issue with refreshing on pages that are defined in app routing module-->
@if (true) {
  <mat-toolbar
             [ngClass]="{'nav__mobile-nav-position': isSmallNav, 'nav': !isSmallNav, 'nav__mobile-nav-container': isMobile,
                         'nav__nav-container': !isMobile}">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between stretch">
      @if (hideBackArrow) {
        <div [ngClass]="{'nav__action-btn-small': isSmallNav, 'nav__action-btn-large': !isSmallNav}"></div>
      }
      @if (!hideBackArrow) {
        <div>
          <button mat-button
              [ngClass]="{'nav__button-small': isSmallNav, 'nav__button': !isSmallNav, 'nav__mobile-nav-container__button-small': isMobile,
                          'nav__nav-container__button': !isMobile}"
            data-testid="back-button"
            (click)="back.emit($event)">
            @if ((isMobile || isBackChevronDT) && !isCloseIcon) {
              <i class="material-icons">arrow_back_ios</i>
            }
            @if (!isMobile && !isBackChevronDT && !isCloseIcon) {
              <i class="material-icons">arrow_back</i>
            }
            @if (isCloseIcon) {
              <i class="material-icons">close</i>
            }
          </button>
        </div>
      }
      <span class="nav__title"
        fxFlex="auto"
        fxLayoutAlign="center center"
          [ngClass]="{'nav__small-title': (title && title.length > 25),
                      'nav__small-title-for-mobile': (title && title.length > 45 && isSmallNav)}"
          [attr.data-testid]="title + 'name'">
        {{title}}
        @if (isFavoriteLocation) {
          <i class="material-icons nav__favorite-icon-red" matTooltip="Favorited This Location">favorite</i>
        }
      </span>
      @if (!actionMenu) {
        <div [ngClass]="{'nav__action-btn-small': isSmallNav, 'nav__action-btn-large': !isSmallNav}"></div>
      }
      @if (actionMenu) {
        <div [ngClass]="{'nav__action-btn-small': isSmallNav, 'nav__action-btn-large': !isSmallNav}">
          <actions-menu [selectedCustomerIds]="customerToEngage"
            [canMakeInactive]="(info) ? info.isInactive : false"
            [isMobile]="isSmallNav"
            [isLoading]="actionMenuLoading"
            [unsavedChangesTitle]="unsavedChangesTitle"
            [unsavedChangesText]="unsavedChangesText"
            [unsavedChangesIcon]="unsavedChangesIcon"
            [unsavedChangesCancel]="unsavedChangesCancel"
            [unsavedChangesConfirm]="unsavedChangesConfirm"
            [shouldDisplayUnsavedChangesDialog]="shouldDisplayUnsavedChangesDialog"
            [disableActionMenu]="disableActionMenu">
          </actions-menu>
        </div>
      }
    </div>
  </mat-toolbar>
}
